import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import MembersGroupUserName from "../../components/membersGroupUser/MembersGroupUserDetail/MembersGroupUserName.tsx";
import {useLocationFormState} from "../../components/membersGroupUser/MembersGroupUserForm/MembersGroupUserUpdateForm";
import MembersGroupUserUpdateFormProvider from "../../components/membersGroupUser/MembersGroupUserForm/MembersGroupUserUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const MembersGroupUserUpdateEditPage = () => {
    
    useTitle(t`Update Members Group User`);

    const { membersGroupUserId: id } = useParams();
    
    return (
        <Box data-testid="MembersGroupUser-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="MembersGroupUser-update-title"
                    >
                        <Trans>Edit Members Group User</Trans>:  <MembersGroupUserName id={id}/>
                    </Typography>
                    <MembersGroupUserUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default MembersGroupUserUpdateEditPage;
